import { render, staticRenderFns } from "./TopNavigationBar.vue?vue&type=template&id=450cf5ff"
import script from "./TopNavigationBar.vue?vue&type=script&lang=js"
export * from "./TopNavigationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports